import { render } from "./CustomerRubric.vue?vue&type=template&id=4be73f2a&ts=true"
import script from "./CustomerRubric.ts?vue&type=script&lang=ts"
export * from "./CustomerRubric.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__